import { render } from "./NewsMain.vue?vue&type=template&id=f286c636&scoped=true"
import script from "./NewsMain.vue?vue&type=script&lang=js"
export * from "./NewsMain.vue?vue&type=script&lang=js"

import "./NewsMain.vue?vue&type=style&index=0&id=f286c636&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f286c636"]])

export default __exports__